import { useState } from "react";
import { QrReader } from "react-qr-reader";
import QrScanDetails from "./QrScanDetails";
import "./qrcode.css";

const QrCode = () => {
  const [qrData, setQrData] = useState(null);

  return (
    <div className="p-3">
      {qrData === null && (
        <div className="text-center p-5 bg-white shadow-lg">
          <div style={{ maxWidth: "300px", margin: "auto" }}>
            <QrReader
              constraints={{ facingMode: "environment" }}
              onResult={(result) => {
                if (result?.text) {
                  setQrData(result.text);
                }
              }}
            />
          </div>
        </div>
      )}
      {qrData && <QrScanDetails qrData={qrData} onReset={() => setQrData(null)} />}
    </div>
  );
};

export default QrCode;
